
  <div [innerHTML]="displayContent" class="standard-font-size"></div>
  <span (click)="toggleContent()" *ngIf="showButton" style="text-decoration: underline; cursor: pointer; font-weight: bold">{{ buttonText }}</span>

